import { api } from "@data-phone/react-resource-server-auth";
import { setAgents, setAgentsError, setAgentsLoading, CallCenterAgent } from "../redux/slices/agents.slice";
import { useApiQuery } from "../hooks/useApiQuery";

import dayjs from "dayjs"

import qs from "qs";
import { QueryOptions } from "react-query";

export interface AgentApiResponse {
    name: string;
    extension: string;
    description: string;
}

export interface AgentsResponse {
    code: number;
    message: string;
    result: AgentApiResponse[];
}

export interface AgentsStat {
    agent_id: string;
    total_answered: string;
}

export interface AgentsStatsResponse {
    code: number;
    message: string;
    data: {
        summary: AgentsStat[]
    };
}

export const fetchCallCenterAgents = async (): Promise<CallCenterAgent[]> => {
    const response = await api.get(
        `${process.env.REACT_APP_LIVE_CALL_URL}/api/callcenter/agents`
    );

    if (response.code !== 200) {
        throw new Error(`Failed to fetch call center agents: ${response.message}`);
    }

    return response.result.map((agent: AgentApiResponse): CallCenterAgent => ({
        id: agent.name,
        name: agent.description,
        extension: agent.extension,
    }));
};

export const fetchCallCenterAgentsStats = async (): Promise<AgentsStatsResponse> => {
    const query = qs.stringify(
        {
            filters: {
                datetime: `${dayjs().startOf('day').toISOString()}~${dayjs().endOf('day').toISOString()}`,
                groupby: {
                    field: "agent_id",
                    unit: "day",
                },
            },
            fields: ["total_answered"],
        },
        { encodeValuesOnly: true }
    );

    const response = await api.get(
        `${process.env.REACT_APP_REPORTING_URL}/agents/stats?${query}`
    );

    if (response.code !== 200) {
        throw new Error(`Failed to fetch call center agents stats: ${response.message}`);
    }

    return response;
};


export const useGetCallCenterAgents = () => {
    return useApiQuery(
        ['callcenter-agents'],
        fetchCallCenterAgents,
        {
            actions: {
                setLoading: setAgentsLoading,
                setSuccess: setAgents,
                setError: setAgentsError
            },

        }
    );
};

export const useGetCallCenterAgentsStats = () => {
    return useApiQuery(
        ['callcenter-agents-stats'],
        fetchCallCenterAgentsStats,
        {}
    );
}

export const agentsService = {
    fetchCallCenterAgents,
};

export default agentsService;
